import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { useQuery } from "react-query";
import { getTeam } from "../../services/GlobalRoles/getTeam";
import { getTeams } from "../../services/GlobalRoles/getTeams";
import { toast } from "react-toastify";
import Modal from "./Modal";
import { Button } from "primereact/button";
import { useAppContext } from "../../context/AppContext";

const ModalTeamSelection = ({ title, visible, setVisible, onFinish }) => {
  const { permissions } = useAppContext();
  const [loadingTeams, setLoadingTeams] = useState(true);
  const [team, setTeam] = useState(false);
  const [members, setMembers] = useState(false);
  const [memberData, setMemberData] = useState(false);

  const [imobiliarias, setImobiliarias] = useState([]);
  const [corretores, setCorretores] = useState([]);

  const [selectedImob, setSelectedImob] = useState(false);
  const [selectedCorr, setSelectedCorr] = useState(false);

  const { data, isLoading } = useQuery({
    queryKey: [`getTeams`],
    queryFn: () => getTeams(),
    enabled: !!permissions?.includes("101")
  });

  const handleMemberData = (memberId) => {
    const filter = members.filter((member) => member.id === memberId);
    setMemberData(filter[0]);
  };

  const handleTeam = async (value) => {
    setLoadingTeams(true);
    setTeam(value);

    const response = await getTeam(value);
    if (!response.members) {
      toast.error("Não há membros!");
      return;
    }

    setMembers(response.members);

    const imobiliariasFiltered = response.members.filter((member) =>
      member.registration_types.some(
        (registration) => registration.name === "Imobiliária"
      )
    );

    const corretoresFiltered = response.members.filter((member) =>
      member.registration_types.some(
        (registration) => registration.name === "Corretor"
      )
    );

    if (imobiliariasFiltered) {
      const imobMembers = imobiliariasFiltered.map((i) => ({
        value: i.id,
        label: i.name,
      }));
      setImobiliarias(imobMembers);
    }

    if (corretoresFiltered) {
      const sellerMembers = corretoresFiltered.map((i) => ({
        value: i.id,
        label: i.name,
      }));
      setCorretores(sellerMembers);
    }
    setLoadingTeams(false);
  };

  const handleSelect = async () => {
    const teamData = {
      teamId: team,
      imobId: selectedImob,
      corrId: selectedCorr,
      brokerData: memberData
    }
    onFinish(teamData)
  };

  return (
    <>
      {data && (
        <>
        <Modal
            visible={visible}
            dynamicTitle={title}
            onHide={() => setVisible(false)}    
          >
            <div className="row">
              <div className="col-md-4 pb-2">
                <label className="mb-3">Time de Venda *</label>
                <Dropdown
                  value={team}
                  onChange={(e) => handleTeam(e.value)}
                  emptyFilterMessage="Nenhuma informação encontrada."
                  emptyMessage="Nenhuma informação encontrada."
                  showClear
                  filter
                  disabled={!data}
                  options={
                    data &&
                    data.map((team) => ({
                      label: team.name,
                      value: team.id,
                    }))
                  }
                  optionLabel="label"
                  placeholder="Selecione"
                  className="bg-none px-0 w-100"
                />
              </div>
              <div className="col-md-4 pb-2">
                <label className="mb-3">Imobiliária *</label>
                <Dropdown
                  value={selectedImob}
                  showClear
                  filter
                  onChange={(e) => setSelectedImob(e.value)}
                  options={imobiliarias}
                  optionLabel="label"
                  emptyFilterMessage="Nenhuma informação encontrada."
                  emptyMessage="Nenhuma informação encontrada."
                  disabled={loadingTeams}
                  placeholder={loadingTeams && team ? "Carregando..." : "Selecione"}
                  className="bg-none px-0 w-100"
                />
              </div>
              <div className="col-md-4 pb-2">
                <label className="mb-3">Vendedor *</label>
                <Dropdown
                  showClear
                  filter
                  value={selectedCorr}
                  onChange={(e) => {
                    setSelectedCorr(e.value);
                    handleMemberData(e.value);
                  }}
                  options={corretores}
                  optionLabel="label"
                  disabled={loadingTeams}
                  placeholder={loadingTeams && team ? "Carregando..." : "Selecione"}
                  className="bg-none px-0 w-100"
                />
              </div>
              <div className="col-12 pt-4 text-end">
              <Button
                  label="Selecionar"
                  icon={"fa-solid fa-check"}
                  iconPos="right"
                  onClick={() => handleSelect()}
                  loading={isLoading}
                />
              </div>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default ModalTeamSelection;

